<!-- <div
  class="absolute h-screen w-screen bg-cover bg-center"
  style="background-image: url('assets/woordkr8/backgrounds/login-background.png')"
></div>
<div class="relative">
</div> -->
<router-outlet></router-outlet>
